export default {
  init() {
    jQuery('.hero__carousel > .owl-carousel').owlCarousel({
      items:1,
      lazyLoad:true,
      stopOnHover: true,
      loop:true,
      margin:0,
      autoplay: true,
    });
    jQuery('.hero__basic > .owl-carousel').owlCarousel({
      items:1,
      lazyLoad:true,
      loop:false,
      margin:10,
      autoplay: false,
  });
  jQuery('.side__by__side__image.owl-carousel').owlCarousel({
      items:1,
      lazyLoad:true,
      loop:false,
      margin:10,
      autoplay: false,
  });
  jQuery('.card__slideshow--mobile.owl-carousel').owlCarousel({
      items:1,
      lazyLoad:true,
      loop:true,
      margin:10,
      autoplay: true,
  dots:false,
  nav:true,
      navText: [
          '<i class=\'fa fa-arrow-left\'></i>',
          '<i class=\'fa fa-arrow-right\'></i>',
      ],
  });
  jQuery('.card__slideshow--large.owl-carousel').owlCarousel({
      items:3,
      //lazyLoad:true,
      loop:false,
      margin:10,
      stagePadding:30,
      autoplay: false,
      merge:true,
      autoWidth:true,
      dots:false,
      nav:true,
      responsiveClass:true,
      responsive:{
          0:{
              items:1,
              stagePadding:90,
          },
          1305:{
              items:2,
              margin:10,
          },
          1920:{
              items:3,
          },
      },
      navText: [
          '<i class=\'fa fa-arrow-left\'></i>',
          '<i class=\'fa fa-arrow-right\'></i>',
      ],
  });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js